import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResizeService {
  private resizeSubject = new Subject<void>();

  resize$ = this.resizeSubject.asObservable();

  triggerResize() {
    // Using a timeout to ensure the view is stable before resizing
    setTimeout(() => this.resizeSubject.next(), 0);
  }
}
